<template>
  <div class="copper-weight-field">
    <div v-for="(item, indx) in items" :key="indx" style="margin-bottom: 8px;">
      <Input placeholder="Such as, L1-L3 or L4" v-model="items[indx].title" @on-change="onChange">
        <Select v-model="items[indx].value" slot="append" style="width: 120px; text-aligh: left" @on-change="onChange">
          <Option v-for="cw in copperWeightList" :value="cw.value" :key="cw.value">{{ cw.label }}</Option>
        </Select>
      </Input>
    </div>
    <Button type="dashed" icon= "ios-add" @click="handleAddClick" style="width: 100%" /></Button>
  </div>
</template>

<script>
import SelectOptions from '../config/select-options.js'
export default {
  name: 'CopperWeightField',
  props: ['value'],
  data () {
    return {
      copperWeightList: SelectOptions.copperWeightList,
      items: []
    }
  },
  mounted () {
    this.items = this.value ? _.cloneDeep(this.value) : []
  },
  methods: {
    handleAddClick () {
      this.items.push({ title: '', value: this.copperWeightList[0].value })
    },
    onChange () {
      this.$emit('input', this.items)
    }
  }
}
</script>

<style>

</style>
